import { CHAT_VERSION } from './version';
export var Environments;
(function (Environments) {
    Environments["LOCAL"] = "http://localhost:8080";
    Environments["DEV"] = "https://api-dev.highmark.com";
    Environments["TEST"] = "https://api-qa.highmark.com";
    Environments["UAT"] = "https://api-qa.highmark.com";
    Environments["PROD"] = "https://api.highmark.com";
})(Environments || (Environments = {}));
export var WebSocketEnvironments;
(function (WebSocketEnvironments) {
    WebSocketEnvironments["LOCAL"] = "ws://localhost:8080";
    WebSocketEnvironments["DEV"] = "wss://ws-dev.highmark.com";
    WebSocketEnvironments["TEST"] = "wss://ws-qa.highmark.com";
    WebSocketEnvironments["UAT"] = "wss://ws-test.highmark.com";
    WebSocketEnvironments["PROD"] = "wss://ws.highmark.com";
})(WebSocketEnvironments || (WebSocketEnvironments = {}));
export class ChatConfig {
    constructor(env, useMocks) {
        this.version = CHAT_VERSION;
        this.useMocks = {};
        this.environment = env;
        this.webSocketEnvironment = this.getWSEnvironment(env);
        this.useMocks = Object.assign({ getAvailability: false, getProviders: false, getTranscripts: false, getSessions: false, getConsent: false, setConsent: false, mockFeatures: false, mockClose: false, ignoreBadMessage: false, mockSupportsAcknowledgements: false, mockNoAcknowledgement: false, mockPingTimeout: false, mockBadFeatureUpdate: false, mockBadParticipantUpdate: false, mockNoTextInput: false, mockNoEventInput: false, mockEWTNotification: false, mockSurveyNotification: false, mockIdleTimeoutNotification: false, mockSessionTimeoutNotification: false, mockRestoreChat: false, mockRestoreChatFail: false, mockUnexpectedWebsocketClose: false, mockReconnectWebsocketFail: false, mockConnectionFail: false, mockStartChatFailNoFeatures: false }, (useMocks !== null && useMocks !== void 0 ? useMocks : {}));
    }
    getWSEnvironment(env) {
        switch (env) {
            case Environments.PROD:
                return WebSocketEnvironments.PROD;
            case Environments.DEV:
                return WebSocketEnvironments.DEV;
            case Environments.TEST:
                return WebSocketEnvironments.TEST;
            case Environments.UAT:
                return WebSocketEnvironments.UAT;
            case Environments.LOCAL:
                return WebSocketEnvironments.LOCAL;
            default:
                throw new Error('Invalid environment');
        }
    }
}
//# sourceMappingURL=chat-config.js.map